<template>
  <div
    class="lang-select limit-px ib"
    @click="langSlideActive = !langSlideActive"
  >
    <span class="currentLanguage">{{ currentLanguage }}</span>
    <div class="lang-select-list" :class="{ active: langSlideActive }">
      <a
        href="javascript:void(0)"
        class="lang-option"
        v-for="(item, index) in langList"
        :key="index"
        @click="changeLang(item.code)"
        >{{ item.name }}</a
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import langHook from "@/hooks/langHook";
const { langSlideActive, langList, changeLang, currentLanguage } = langHook();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";
.lang-select {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  font-size: 18px;
  position: relative;
  cursor: pointer;
  height: 45px;
  background: $btnColor;
  padding-left: 20px;
  border-radius: 10px;
  z-index: 1;
  @media (orientation: landscape) {
    font-size: 18px;
    width: 220px;
    height: 45px;
    padding-left: 20px;
  }
  @media (orientation: portrait) {
    width: 180px;
  }
  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    right: 20px;
    @include setBackground(20px, 12px, "arrow_down.png");
    @media (orientation: landscape) {
      width: 20px;
      height: 12px;
      right: 20px;
    }
  }
  .lang-select-list {
    position: absolute;
    z-index: -1;
    width: 100%;
    background: #fff;
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    box-sizing: content-box;
    top: -100%;
    display: none;
    left: 0;
    transition: all 0.4s;
    &.active {
      top: 110%;
      display: block;
    }
    .lang-option {
      width: 100%;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      color: #000;
      @media (orientation: landscape) {
        height: 45px;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
